import { useRouter } from 'next/router';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';

export const useGATracking = () => {
  const router = useRouter();

  useEffect(() => {
    ReactGA.initialize(process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID!);

    const handleRouteChange = (path: string) => {
      ReactGA.send({
        hitType: 'pageView',
        page: path,
      });
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);
};
